import React, { useEffect, useRef } from 'react';
import { DataSet, Network } from 'vis-network/standalone';

export default function MmcGraph({ edges, nodes, handleSelected }) {
  const graphRef = useRef(null);

  useEffect(() => {
    const data = {
      nodes: new DataSet(nodes),
      edges: new DataSet(edges),
    };

    const options = {
      physics: {
        enabled: false,
      },
      interaction: {
        hover: true,
        selectable: true,
      },
    };

    const network = new Network(graphRef.current, data, options);

    const handleNodeClick = (params) => {
      if (params.nodes.length) {
        handleSelected(params.nodes[0]);
      }
    };

    network.on('selectNode', handleNodeClick);

    return () => {
      network.off('selectNode', handleNodeClick);
    };
  }, [edges, nodes, handleSelected]);

  return <div ref={graphRef} style={{ width: '100%', height: '100%' }} />;
}